import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import auth from "../firebase/auth";
import axiosJwt from "../utils/axiosJwt";

export default function DeleteConfirmationModal({ id, toast, refetch }) {
  const navigate = useNavigate();

  const handleDeleteProduct = () => {
    axiosJwt
      .delete(`${process.env.REACT_APP_SERVER_ENDPOINT}/parts/${id}`)
      .then(({ data }) => {
        if (data.deletedCount) {
          refetch();

          toast.info("Deleted Product Successfully");
        } else {
          toast.error("Couldn't Delete Product");
        }
      })
      .catch((error) => {
        if ([401, 403].includes(error?.response?.status)) {
          signOut(auth);

          localStorage.removeItem("token");

          navigate("/login");
        }

        toast.error("Couldn't Delete Product");
      });
  };

  return (
    <>
      <input type="checkbox" id={id} class="modal-toggle" />
      <div class="modal modal-bottom sm:modal-middle">
        <div class="modal-box">
          <p class="font-bold py-2">
            Are you sure you want to delete the product?
          </p>

          <div class="modal-action pb-2">
            <label
              for={id}
              class="mr-auto btn bg-blue-600 hover:bg-blue-700 border-0"
            >
              Go Back
            </label>

            <label
              onClick={handleDeleteProduct}
              for={id}
              class="btn bg-red-600 hover:bg-red-700 border-0"
            >
              Delete Product
            </label>
          </div>
        </div>
      </div>
    </>
  );
}
